import React from 'react'
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { BecomeAfiliateData } from "../Common/data/mapData";
import Tooltips from '../Common/Tooltip';

const AgentEditDialog = (props) => {
    const { filedsHandler, onSave, agentEditError, affiliateInput } = props;
    return (
        <div className="space-y-6 py-4">
            {BecomeAfiliateData.map((item, ind) => {
                const hasError = agentEditError.length > 0 && agentEditError.includes(item.name);
                return (
                    <div key={item.id} className="space-y-2">
                        <div className="flex items-center gap-2">
                            <Label htmlFor={item.name} className="text-sm font-medium">
                                {item.title}
                            </Label>
                            <Tooltips info={item.info} />
                        </div>
                        <Input
                            id={item.name}
                            name={item.name}
                            type="text"
                            value={affiliateInput[item.name] || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (item.regex) {
                                    if (item.regex.test(value) || value === "") {
                                        filedsHandler(e, "dialog");
                                    }
                                } else {
                                    filedsHandler(e, "dialog");
                                }
                            }}
                            className={hasError ? "border-destructive" : ""}
                        />
                        {hasError && (
                            <p className="text-sm text-destructive">{item.errorMsg}</p>
                        )}
                    </div>
                );
            })}
            <div className="flex justify-center pt-4">
                <Button
                    onClick={(e) => onSave(e)}
                    variant="default"
                    type="button"
                    className="w-full sm:w-auto"
                >
                    Save Changes
                </Button>
            </div>
        </div>
    )
}

export default AgentEditDialog
